<section class="ecb-shell py-5 text-center">
  <h1 class="ecb-section-title">Page not found</h1>
  <p class="ecb-muted">The requested page does not exist.</p>
  <a routerLink="/" class="ecb-btn-primary">Go home</a>
</section>